const platform = `<svg viewBox="0 0 15.0350005 14.308">
    <g stroke="currentColor" stroke-width="1" fill="none" stroke-linejoin="round">
        <g transform="translate(0.5, 0.5)">
            <path d="M10.743,4.216 L12.957,5.802 L7.185,9.842 L1.448,5.802 L3.647,4.215 M2.5,6.55 L2.22044605e-16,8.382 L6.996,13.308 L14.035,8.382 L11.705,6.7 M2.472,3.402 L7.187,6.723 L11.929,3.403 L7.187,0 L2.473,3.402 L2.472,3.402 Z"></path>
        </g>
    </g>
</svg>`
export default platform